import { Component, input } from '@angular/core';
import { ThemePipe } from '../../../core/pipes/theme.pipe';
import { IconComponent } from '../../icon/icon/icon.component';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'app-countdown-pill',
  templateUrl: './countdown-pill.component.html',
  styleUrls: ['./countdown-pill.component.scss'],
  imports: [NgClass, NgStyle, IconComponent, ThemePipe],
})
export class CountdownPillComponent {
  readonly timeRemaining = input.required<string>();
  readonly size = input<'extra-small' | 'small' | 'medium' | 'large'>('small');

  readonly pillStyles: [string, string][] = [
    ['background', 'pill-countdown'],
    ['border', 'pill-countdown'],
    ['drop-shadow', 'pill-countdown'],
    ['border-radius', 'pill-countdown'],
  ];

  readonly labelStyles: [string, string][] = [
    ['type', 'pill-countdown-label'],
    ['text-color', 'pill-countdown-label'],
  ];
}
